var _circle, _path, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16PxBulletList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 3.5,
    cy: 3.5,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.5 2.5h7M8.5 6.5h7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 3.5,
    cy: 12.5,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.5 11.5h7M8.5 15.5h7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16PxBulletList);
export default __webpack_public_path__ + "static/media/16px_bullet-list.f69ebd080d03a9fc570185ad75bfa3dc.svg";
export { ForwardRef as ReactComponent };